import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogAbsenceComponent } from '../dialog-absence/dialog-absence.component';
import { FileService } from '../../file.service';
import { OroService } from '../../oroservice';

export interface DialogData {
    aufgabe: any;
}

@Component({
    selector: 'app-dialog-task',
    templateUrl: './dialog-task.component.html',
    styleUrls: ['./dialog-task.component.scss'],
    standalone: false
})
export class DialogTaskComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<DialogAbsenceComponent>,
        public oroservice: OroService,
        public fileservice: FileService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
            fileservice.removeAllFiles();
        }

    ngOnInit(): void {
    }

    public canSubmit() : Boolean {
        return (this.fileservice.files.length > 0);
    }

    public submit(): void {
        let formdata = this.fileservice.getfiles();
        const send = {
            Art : this.data.aufgabe.Art,
            Texte : null,
            Entity: this.data.aufgabe.Entity,
            Processtyp : 2 // Dossier
        }

        const json = JSON.stringify(send);
        formdata.append("antwort", json);
        this.oroservice.setAntwort(formdata).then((object) => {
            if (object != null && object.status === 400) {
                this.dialogRef.close(true);
            } else {
                this.fileservice.files = [];
                this.dialogRef.close(true);
            }
        });
    }
}
